module.exports = __webpack_public_path__ + "img/Steor-Icons-10.d6d24232.svg";